import React from "react";
import StoreRow from "./StoreRow";

export default function StoreTable({
  data,
  openIndex,
  popoverRefs,
  onTogglePopover,
  onOpenDiscount,
  onAccessApp,
}) {
  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-white">
            <tr>
              {[
                "Full Name",
                "Email",
                "Installation Date",
                "Status",
                "Current Plan",
                "Shop URL",
                "Payment",
                "Actions",
              ].map((label) => (
                <th
                  key={label}
                  className={`px-6 py-4 text-left text-sm font-medium text-gray-900 whitespace-nowrap ${label === "Actions" ? "text-right" : ""
                    }`}
                >
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {data.map((store, idx) => (
              <StoreRow
                key={store._id}
                store={store}
                isOpen={openIndex === idx}
                anchorRef={(el) => (popoverRefs.current[idx] = el)}
                onToggle={() => onTogglePopover(idx)}
                onOpenDiscount={() => onOpenDiscount(store, idx)}
                onAccessApp={() => onAccessApp(store)}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
